/**
 * @generated SignedSource<<6fe4165f684a0f35c296b36ababd6361>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "Header_navigationItems",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderWithComplexMenuDesktop_navigationItems"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderWithComplexMenuMobile_navigationItems"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderWithSimpleMenu_navigationItems"
    }
  ],
  "type": "NavigationItem",
  "abstractKey": null
};

node.hash = "0d501485981b827a2d05f4ce9f8d1577";

module.exports = node;
